import {
  Box,
  Button,
  ClickAwayListener,
  Grid,
  List,
  ListItemButton,
  ListItemText,
  Paper,
  Popper,
  Typography,
  useMediaQuery
} from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import Transitions from '../../components/@extended/Transitions';
import { useFormik } from 'formik';
import { Values } from './AddMerchantCashAdvance';

export interface Props {
  disabled: boolean;
  formik: ReturnType<typeof useFormik<Values>>;
}

export const SetMcaType = ({ formik, disabled }: Props) => {
  const theme = useTheme();
  const matchesXs = useMediaQuery(theme.breakpoints.down('md'));
  const anchorRef = useRef<any>(null);
  const [mcaType, setMcaType] = useState<'NEW' | 'REFI'>(() => (formik.values?.isRefi ? 'REFI' : 'NEW'));

  const [open, setOpen] = useState(false);
  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event: MouseEvent | TouchEvent) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
  };

  useEffect(() => {
    setMcaType(formik.values?.isRefi ? 'REFI' : 'NEW');
  }, [formik.values?.isRefi]);

  const handleListItemClick = async (type: 'NEW' | 'REFI') => {
    setOpen(false);
    if (type === 'REFI') {
      formik.setFieldValue('isRefi', true);
    } else {
      formik.setFieldValue('isRefi', false);
      formik.setFieldValue('refiLevel', null);
      formik.setFieldValue('refis', []);
    }
    setMcaType(type);
  };

  return (
    <Box sx={{ flexShrink: 0, zIndex: 1000 }}>
      <Button
        variant="outlined"
        color={mcaType === 'NEW' ? 'primary' : 'info'}
        size={'small'}
        ref={anchorRef}
        aria-controls={open ? 'localization-grow' : undefined}
        aria-haspopup="true"
        onClick={handleToggle}
        disabled={disabled}
      >
        {mcaType}
      </Button>
      <Popper
        placement={'bottom-end'}
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
        popperOptions={{
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: [matchesXs ? 0 : 0, 9]
              }
            }
          ]
        }}
      >
        {({ TransitionProps }) => (
          <Transitions type="grow" position={matchesXs ? 'top-right' : 'top'} in={open} {...TransitionProps}>
            <Paper sx={{ boxShadow: theme.customShadows.z1 }}>
              <ClickAwayListener onClickAway={handleClose}>
                <List
                  component="nav"
                  sx={{
                    p: 0,
                    width: '100%',
                    maxWidth: 160,
                    bgcolor: theme.palette.background.paper,
                    borderRadius: 0.5,
                    [theme.breakpoints.down('md')]: {
                      maxWidth: 250
                    }
                  }}
                >
                  <ListItemButton key={'NEW'} onClick={() => handleListItemClick('NEW')}>
                    <ListItemText
                      primary={
                        <Grid container>
                          <Typography color="#85A5FF">NEW</Typography>
                        </Grid>
                      }
                    />
                  </ListItemButton>
                  <ListItemButton key={'REFI'} onClick={() => handleListItemClick('REFI')}>
                    <ListItemText
                      primary={
                        <Grid container>
                          <Typography color="#36CFC9">REFI</Typography>
                        </Grid>
                      }
                    />
                  </ListItemButton>
                </List>
              </ClickAwayListener>
            </Paper>
          </Transitions>
        )}
      </Popper>
    </Box>
  );
};
